/**
 * How a claim follows the room's finish (rest-api.md #room-finish), one rule for Edge Admin's claim sheet and the
 * Service page's claim footer.
 */
/** How long after a claim a gaps result the finish is still working on is followed. */
export const CLAIM_FOLLOW_MS = 10 * 60_000;
/** Gap reasons that only say the claimed controller's records have not arrived yet (Edge's WAITING less `gateway_offline`). */
export const FINISH_WAITING_REASONS = new Set(['claim_pending', 'inventory_pending', 'missing_device']);
/**
 * Gap reasons the finish resolves by itself after a claim: records still arriving, its own writes not read back yet
 * (Edge's PENDING), and kit slots it binds once the channels and routes are there. T10 bench: Soba 1's sheet and footer
 * stopped on "2 default(s) of CTTH-424 Zone Thermostat do not read back yet" and "HVAC zone probe is not bound", and the
 * room was Ready 81 s and 134 s later.
 */
export const FINISH_WORKING_REASONS = new Set([
    ...FINISH_WAITING_REASONS,
    'config_pending', 'policy_pending', 'publication_pending', 'route_unconfirmed', 'missing_slot', 'invalid_binding',
]);
/** A finish run is still working: no result yet, or a stage that is neither Ready nor gaps. */
export function finishIsActive(result) {
    if (!result)
        return true;
    return !result.ready && result.stage !== 'gaps' && result.stage !== 'ready';
}
/** The first gap of a gaps result that the finish is still working on, or null. */
export function finishWorkingGap(result) {
    if (!result || result.ready || result.stage !== 'gaps')
        return null;
    return (result.gaps ?? []).find(gap => FINISH_WORKING_REASONS.has(gap.reason))?.reason ?? null;
}
/**
 * After a claim, the finish is followed while a run is active, and a gaps result while one of its gaps is one the
 * finish is still working on, until `followSince + CLAIM_FOLLOW_MS`. Ready, or any other gaps result, is the outcome.
 */
export function claimFollowsFinish(result, followSince, now) {
    return finishIsActive(result) || (finishWorkingGap(result) !== null && now - followSince < CLAIM_FOLLOW_MS);
}
//# sourceMappingURL=roomFinishFollow.js.map